<template>
  <div class="mb-4">
    <div class="d-flex flex-column ml-3 regular-16" :class="addressObject.inactive ? 'strikethrough-text text-muted' : ''">
      <span>{{ addressObject.street1 }}</span>
      <span>{{ addressObject.street2 }}</span>
      <span>{{ addressObject.city }}, {{ addressObject.state }} {{ addressObject.zip_code }}</span>
      <span>{{ addressObject.country_name }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "PersonAddressDetail",
  props: ['addressObject']
}
</script>
